import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b1ef2c0")

_pushScopeId("data-v-4b1ef2c0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Sondaggi")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "no_sondaggi_container"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "no_sondaggi" }, "Nessun sondaggio da compialre", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "container_sondaggi" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "sondaggio_name" }
const _hoisted_10 = { class: "counter" }
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadSondaggi()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                (!$setup.sondaggi.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.sondaggi, (sondaggio) => {
                          return (_openBlock(), _createBlock("div", {
                            key: sondaggio.sondaggi_id,
                            onClick: ($event: any) => ($setup.openDetailPage(sondaggio)),
                            class: "sondaggio"
                          }, [
                            _createVNode("div", _hoisted_8, [
                              _createVNode("div", _hoisted_9, [
                                _createVNode("span", null, _toDisplayString($setup.setShortSondaggioTitle(sondaggio.sondaggi_titolo)), 1)
                              ]),
                              _createVNode("div", _hoisted_10, [
                                _createVNode("span", null, _toDisplayString($setup.dateFormat(sondaggio.sondaggi_creation_date)), 1),
                                _createVNode("span", null, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', 'users'],
                                    style: {"color":"#7f8085","font-size":"12px"}
                                  }),
                                  _createTextVNode(" " + _toDisplayString(sondaggio.totale_compilazioni), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_11, [
                              (sondaggio.ha_compilato === 1)
                                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: $setup.checkmarkCircle,
                                      class: "sondaggio_action complete"
                                    }, null, 8, ["icon"])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_13, [
                                    _createVNode(_component_ion_icon, {
                                      slot: "start",
                                      icon: $setup.arrowForward,
                                      color: "white",
                                      class: "sondaggio_action"
                                    }, null, 8, ["icon"])
                                  ]))
                            ])
                          ], 8, ["onClick"]))
                        }), 128))
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})